import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CTABanner() {
    return (
        <section
            data-testid="cta-banner"
            className="relative py-24 lg:py-36 bg-white border-t border-acre-line"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end">
                <div className="lg:col-span-8">
                    <div className="flex items-center mb-6">
                        <span className="acre-tick" />
                        <span className="text-[11px] uppercase tracking-[0.28em] text-acre-muted">
                            Engagement Inquiries
                        </span>
                    </div>
                    <h2 className="font-serif-display text-4xl lg:text-6xl tracking-tight leading-[1.02] text-acre-secondary max-w-3xl">
                        Initial consultations are arranged by email. Messages are ordinarily returned within one business day.
                    </h2>
                </div>
                <div className="lg:col-span-4 flex flex-col items-start gap-6 lg:pl-8 lg:border-l lg:border-acre-line">
                    <div>
                        <div className="text-[11px] uppercase tracking-[0.28em] text-acre-muted mb-2">
                            Email
                        </div>
                        <a
                            href="mailto:info@chesterton.law"
                            data-testid="cta-banner-email"
                            className="font-serif-display text-2xl lg:text-3xl text-acre-secondary hover:opacity-80 transition-opacity"
                        >
                            info@chesterton.law
                        </a>
                    </div>
                    <Link
                        to="/contact"
                        data-testid="cta-banner-primary"
                        className="group inline-flex items-center gap-3 bg-acre-primary text-white px-7 py-4 text-[11px] uppercase tracking-[0.22em] font-semibold hover:bg-acre-primaryHover transition-all"
                    >
                        Contact the Firm
                        <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                    </Link>
                </div>
            </div>
        </section>
    );
}
